import { useMutation, useQueryClient } from 'react-query';
import axios from '../../../utils/axios';
import { apiurl } from '../../../config/apiUrl';

const postAdvancePoCancellationQuery = (payload) => {
  const purchaseId = payload.purchaseOrderId;
  const advancePoId = payload.advancePurchaseOrderId ?? payload.arqId;
  const searchParams = new URLSearchParams({
    advancePoId: String(advancePoId ?? ''),
    purchaseId: String(purchaseId ?? '')
  });
  const url = `${apiurl?.getAdvancePoCancellation}?${searchParams.toString()}`;
  return axios.post(url);
};

const postAdvancePoCancellation = () => {
  const queryClient = useQueryClient();
  return useMutation(['postAdvancePoCancellation'], postAdvancePoCancellationQuery, {
    onSuccess: (response, variables) => {
      if (variables?.purchaseOrderId) {
        queryClient.invalidateQueries('getPO');
        queryClient.invalidateQueries(['getAdvanceRequestPurchaseOrder', variables.purchaseOrderId]);
      }
    }
  });
};

export default postAdvancePoCancellation;
